

$('table .quantity:first').focus();
$('[max]').change(function () {
    var max = parseInt($(this).attr('max'), 10);
    var value = parseInt($(this).val(), 10) || 0;
    if (value > max) {
        alert('We only have ' + max + ' of this item in stock');
        $(this).val(max);
    }
});

$('select.variant-select').change(function (e) {
    var product = $(this).attr("product");
    var variant = $(this).val();
    var price = $("#option-" + variant).attr("price");
    var max = $("#option-" + variant).attr("max");

    $("#" + product).attr("name", "updates[" + variant + "]");
    $("#" + product).attr("max", max);
    $("#" + product).attr("data-variant-id", variant);
    $("#price-" + product).html(price);
});


$('.btn-add-to-cart').click(function (event) {
    event.preventDefault(); // Prevent default form submission

    // Initialize an empty array to store product data
    var productData = [];
    // Iterate through all product input elements
    $('.quantity-input').each(function() {
        var productId = $(this).attr('data-product-id'); // Extract product ID from input ID
        var variantId = $(this).attr('data-variant-id'); // Extract variant ID from input name
        var quantity = parseInt($(this).val()); // Convert quantity to integer

        // Filter out products with zero quantity
        if (quantity > 0) {
            productData.push({
                id: variantId,
                quantity: quantity
            });
        }
    });


    // Check if there are any valid products before sending the request
    if (productData.length > 0) {

        let formData = {
            'items': productData
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                console.log(response.json());

                window.location.href = "/cart";

            })
            .catch((error) => {
                console.error('Error:', error);
            });

    } else {
        // No products selected, handle appropriately
        alert('Please select at least one product with a quantity greater than zero.');
    }
});